const Programs = () => {
  const trainingAreas = [
    { name: 'Phát triển bản thân', icon: '🌱' },
    { name: 'Tư duy', icon: '🧠' },
    { name: 'Bán hàng', icon: '💼' },
    { name: 'Marketing', icon: '📈' },
    { name: 'Xây dựng đội nhóm', icon: '👥' },
    { name: 'Lãnh đạo', icon: '👑' },
    { name: 'Coaching', icon: '🎯' },
  ];

  const programs = [
    {
      title: 'MASTER THE LIFE GAME',
      description:
        'Chương trình phát triển bản thân toàn diện, giúp bạn làm chủ cuộc đời mình',
      level: 'Cơ bản - Nâng cao',
      duration: '3 ngày',
      highlight: 'Bestseller',
      color: 'from-blue-500 to-blue-600',
    },
    {
      title: 'ULTIMATE SALES SKILL A-Z',
      description:
        'Bán Hàng Đỉnh Cao Từ A-Z - Khóa học bán hàng chuyên nghiệp nhất',
      level: 'Chuyên nghiệp',
      duration: '1 ngày',
      highlight: 'Hot',
      color: 'from-green-500 to-green-600',
    },
    {
      title: 'LEADERSHIP FOR RESULT',
      description:
        'Phát triển kỹ năng lãnh đạo hiệu quả và tạo ra kết quả vượt trội',
      level: 'Quản lý',
      duration: '1 ngày',
      highlight: 'New',
      color: 'from-purple-500 to-purple-600',
    },
    {
      title: 'BECOME THE SALES MASTER',
      description:
        'Trở thành bậc thầy bán hàng với những kỹ thuật tiên tiến nhất',
      level: 'Chuyên gia',
      duration: '3 ngày',
      highlight: 'Premium',
      color: 'from-red-500 to-red-600',
    },
    {
      title: 'COACH THE COACH',
      description: 'Chương trình đào tạo Become The Life Coach chuyên nghiệp',
      level: 'Chuyên gia',
      duration: '12 ngày',
      highlight: 'Certification',
      color: 'from-indigo-500 to-indigo-600',
    },
    {
      title: 'ELITE CAMP',
      description: 'Trại Lãnh Đạo Thực Chiến - Chương trình duy nhất trong năm',
      level: 'Đặc biệt',
      duration: '3 ngày',
      highlight: 'Exclusive',
      color: 'from-yellow-500 to-yellow-600',
    },
    {
      title: 'DRAGON CAMP',
      description: 'Trại Luyện Sống - Rèn luyện tinh thần và ý chí vượt khó',
      level: 'Thử thách',
      duration: '4 ngày 3 đêm',
      highlight: 'Challenge',
      color: 'from-orange-500 to-orange-600',
    },
    {
      title: 'LEADER COACHING',
      description: 'Coaching cá nhân cho lãnh đạo về Personality & Business',
      level: '1-on-1',
      duration: 'Linh hoạt',
      highlight: 'Personal',
      color: 'from-teal-500 to-teal-600',
    },
  ];

  return (
    <section id="programs" className="section-padding bg-gray-50">
      <div className="container-custom">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            KHÁM PHÁ CÁC CHƯƠNG TRÌNH
          </h2>
          <p className="text-xl text-primary font-semibold mb-4">
            ĐÀO TẠO ĐỘT PHÁ TẠI UPOWER
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            Upower đã thực hiện thành công rất nhiều chương trình đào tạo về
            Phát Triển Bản Thân, Marketing, Bán hàng, Lãnh đạo, Xây dựng đội
            nhóm, Coaching cho hàng chục nghìn doanh nhân & khởi nghiệp tại Việt
            Nam.
          </p>
        </div>

        {/* Training Areas */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-8">
            Các lĩnh vực đào tạo chính
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4">
            {trainingAreas.map((area, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-4 text-center shadow-sm hover:shadow-lg transition-all duration-300 hover:scale-105 border border-gray-100 hover:border-primary/30"
              >
                <div className="text-2xl mb-2">{area.icon}</div>
                <div className="text-sm font-medium text-gray-700">
                  {area.name}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Programs Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-12">
          {programs.map((program, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group"
            >
              {/* Header with gradient */}
              <div
                className={`bg-gradient-to-r ${program.color} p-6 text-white relative`}
              >
                {/* Highlight Badge */}
                <div className="absolute top-4 right-4">
                  <span className="bg-white/20 backdrop-blur-sm px-2 py-1 rounded-full text-xs font-semibold">
                    {program.highlight}
                  </span>
                </div>

                <h3 className="text-lg font-bold mb-2 pr-16">
                  {program.title}
                </h3>

                <div className="flex items-center justify-between text-sm opacity-90">
                  <span>{program.level}</span>
                  <span>{program.duration}</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <p className="text-gray-600 leading-relaxed">
                  {program.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="bg-gradient-to-r from-primary to-primary-700 rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">
            Sẵn sàng bắt đầu hành trình phát triển?
          </h3>
          <p className="text-lg md:text-xl text-primary-100 mb-8 max-w-3xl mx-auto leading-relaxed">
            Thời gian qua, chúng tôi đã phục vụ hàng trăm ngàn người tại Việt
            Nam với mục tiêu nhằm phụng sự xã hội gắn cùng sứ mệnh: &ldquo;Vì
            một cộng đồng sống có mục đích&rdquo;.
          </p>

          <div className="flex justify-center">
            <button
              onClick={() => {
                const element = document.querySelector('#contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-white text-primary font-semibold py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors duration-300"
            >
              Đăng ký tư vấn khóa học
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Programs;
